import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1698d65a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "deactivate_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "deactivate_title" }, "退会のお手続きが完了しました", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deactivate_text" }, [
  /*#__PURE__*/_createTextVNode(" マスメディアンをご利用いただき "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ありがとうございました "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" またのご利用を心よりお待ちしております ")
], -1))
const _hoisted_4 = { class: "deactivate_button" }
const _hoisted_5 = { class: "deactivate_button_top" }

import LinkToTopButton from '@/components/LinkToTopButton.vue';
import { onBeforeMount } from 'vue';
import { postAuthLogout } from '@/api/accountEndpoint';
import store from '@/store';

// トークンを破棄する

export default /*#__PURE__*/_defineComponent({
  __name: 'DeactivateCompleteView',
  setup(__props) {

onBeforeMount(async() => {
  try {
    postAuthLogout();
    store.commit('router/initLoginTransitionData');
  } catch (error) {
    console.error(error);
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(LinkToTopButton, null, {
            default: _withCtx(() => [
              _createTextVNode("マスメディアンTOPへ")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})